import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import getAxiosInstance from "../api/axiosInstance";

const getFirstInitial = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase();
};

const Guest = () => {
    const [guestList, setGuestList] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const axiosInstance = getAxiosInstance();

    useEffect(() => {
        const fetchGuestList = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await axiosInstance.get(
                    "/guests?is_active=true&noPaging=true&orderBy=first_name&&order=1"
                );
                setGuestList(response.data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchGuestList();
    }, []);

    const handleGuestClick = (guest) => {
        navigate("/checkin-out", {
            state: { userType: "guest", selectedUser: { id: guest.guest_id, ...guest } },
        });
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen w-screen">
                Loading...
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex justify-center items-center h-screen w-screen">
                Error: {error.message}
            </div>
        );
    }

    return (
        <div
            className="py-8 xl:p-8 mx-auto my-0 h-auto"
            style={{
                height: "calc(100% - 64px)",
                width: "calc(100% - 80px)",
                "@media (max-width: 1024px)": { width: "calc(100% - 60px)" },
            }}
        >
            <div className="grid grid-cols-1 md:grid-cols-[auto_5.5rem_1fr] gap-6 w-full items-stretch content-start">
                <div className="flex justify-center md:justify-start">
                    <Link
                        to="/new-guest"
                        className="button-lg text-center shrink-0 flex items-center justify-center"
                        style={{
                            width: "clamp(18rem, 30vw, 28rem)",
                            height: "clamp(20rem, 40vw, 32rem)",
                        }}
                    >
            <span className="leading-tight">
              New <br />
              Guest
            </span>
                    </Link>
                </div>

                <div className="hidden md:flex items-center justify-center h-full">
                    <div className="font-primary font-medium text-lg xl:text-xl whitespace-nowrap select-none">
                        -OR-
                    </div>
                </div>
                <div className="md:hidden flex justify-center">
                    <div className="font-primary text-sm opacity-80 my-3 select-none">-OR-</div>
                </div>

                <div className="w-full">
                    <div className="grid gap-4 items-start content-start [grid-template-columns:repeat(auto-fit,minmax(12rem,1fr))]">
                        {guestList &&
                            guestList.map((guest, index) => (
                                <div
                                    key={index}
                                    className="bg-darkgrey px-4 py-4 rounded-4 cursor-pointer text-center flex flex-col justify-center hover:bg-orange focus:bg-orange min-h-[5.5rem]"
                                    onClick={() => handleGuestClick(guest)}
                                >
                                    <h2 className="text-lg font-bold break-words">
                                        {getFirstInitial(guest.first_name)}
                                    </h2>
                                    <p className="text-lg font-bold break-words">{guest.last_name}</p>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Guest;
